import { get, post, downloadFile } from "../api_helper";

const getUserOpenChat = async (chatID) => {
  if (chatID) {
    const url = "get-user-open-chat?chatID=" + chatID;
    const response = await get(url);
    return response;
  } else {
    const url = "get-user-open-chat?";
    const response = await get(url);
    return response;
  }
};

const getUserChats = async () => {
  const url = "get-user-chats";
  const response = await get(url);
  return response;
};

const deleteUserChat = async (chatID) => {
  const url = "delete-user-chat?chatID=" + chatID;
  const response = await get(url);
  return response;
};

const startNewChat = async () => {
  const url = "start-new-chat";
  const response = await get(url);
  return response;
};

const insertMessage = async (data) => {
  const url = "insert-message";
  const response = await post(url, data);
  return response;
};

const saveMedications = async (data) => {
  const url = "save-medications";
  const response = await post(url, data);
  return response;
};

const saveAnswer = async (data) => {
  const url = "save-answer";
  const response = await post(url, data);
  return response;
};

const EditLastAnswer = async (data) => {
  const url = "edit-last-answer";
  const response = await post(url, data);
  return response;
};

const uploadInsuranceCard = async (data) => {
  const url = "upload-insurance-card";
  const response = await post(url, data);
  return response;
};

const uploadDocument = async (data) => {
  const url = "upload-report-document";
  const response = await post(url, data);
  return response;
};

const saveConsentForm = async (data) => {
  const url = "save-consent-form";
  const response = await post(url, data);
  return response;
};

const downloadPrescriptionQFGold = async () => {
  const url = "downloads/prescription-tb-gold-quantiferon";
  const response = await downloadFile({
    url: url,
  });
  return response;
};

const downloadPrescriptionChestXray = async () => {
  const url = "downloads/prescription-chest-xray";
  const response = await downloadFile({
    url: url,
  });
  return response;
};

const downloadPrescription = async (payload) => {
  const url = "download-prescription";
  const response = await downloadFile({
    url: url,
    data: payload,
    method: "POST",
  });
  return response;
};

export {
  getUserOpenChat,
  getUserChats,
  deleteUserChat,
  startNewChat,
  insertMessage,
  saveMedications,
  saveAnswer,
  EditLastAnswer,
  uploadInsuranceCard,
  uploadDocument,
  saveConsentForm,
  downloadPrescriptionQFGold,
  downloadPrescriptionChestXray,
  downloadPrescription,
};
